import { TAnswers } from 'models/common.model'
import { useMemo } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useGetSavedAnswers = (): Partial<TAnswers> | null => {
  const { answersFromBE } = useZustandStore(
    useShallow((state) => ({
      answersFromBE: state.lead?.quizzes || null,
    })),
  )
  const { answersFromLocal } = useZustandSessionStore(
    useShallow((state) => ({
      answersFromLocal: state.userAnswers || null,
    })),
  )

  const answers = useMemo(() => ({ ...answersFromBE, ...answersFromLocal }), [
    answersFromBE,
    answersFromLocal,
  ])

  return answers
}
